import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useLocation } from 'react-router-dom';
import { v4 } from 'uuid';
export const PageSkipLink = ({ showSkipLink, sectionId, description }) => {
    const uid = v4();
    const location = useLocation();
    return showSkipLink ? (_jsxs(_Fragment, { children: [_jsx("div", { id: sectionId, tabIndex: -1 }), _jsxs("a", Object.assign({ href: `${location.pathname}#${sectionId}` }, { children: ["Ga naar ", description] }), uid)] })) : null;
};
